import React from 'react';
import { HeroBackground } from './components/HeroBackground/HeroBackground';
import { HeroFloats } from './components/HeroFloats/HeroFloats';
import { HeroContent } from './components/HeroContent/HeroContent';
import './HeroSection.css';

export function HeroSection() {
  return (
    <section className="hero-section">
      <HeroBackground />
      <HeroFloats />
      <HeroContent />
    </section>
  );
}
